// =============================================================
// MUNDALO - Single source of truth for tier PRICING COPY.
//
// If you need to change a tagline, description, or bullet for
// Blueprint Only / Essentials / Guided, change it HERE. Every
// surface that renders tier copy (homepage pricing section, the
// Get Your Blueprint intake tier step, /quiz-upsell, quiz
// results, in-portal pricing, /start) reads from this file.
//
// Notes:
//   - Prices, Stripe price IDs, and checkout logic live elsewhere
//     (constants/tiers.js + backend). Do NOT put those here.
//   - Copy must use hyphens (-), never em dashes (--).
// =============================================================

export const PRICING_CONTENT = {
  blueprint_only: {
    id: 'blueprint_only',
    name: 'Blueprint Only',
    price: 199,
    priceLabel: '$199',
    interval: 'one-time',
    tagline: 'Stop reading forums. Start packing.',
    description:
      "Every question you've been Googling for months, answered for your specific situation, in one document. Built from your intake - your income, your timeline, your city, your family. Not generic advice. You'll know your exact path within 24 hours of submitting your details. If your Blueprint doesn't cover your situation, we'll revise it free.",
    bullets: [
      'The exact visa path for your income and timeline',
      'How to import your vehicle without losing it at the border',
      'Where expats actually live - neighborhood breakdowns by your budget',
      'The banking setup that keeps your US credit intact',
      'How to get your kids into the right school without the runaround',
      "What healthcare actually costs and which plan won't leave you stranded",
      '24-hour chat support trained specifically for this move',
    ],
  },
  essentials: {
    id: 'essentials',
    name: 'Essentials',
    price: 349,
    priceLabel: '$349',
    interval: 'one-time',
    tagline: 'The plan, the lessons, the human. Once.',
    description:
      'For the mover who wants to understand everything themselves. Your personalized Blueprint, plus the full Classroom to master every topic, plus vetted professionals to call when it gets real. One payment, permanent access.',
    bullets: [
      'Everything in Blueprint Only',
      'Full Classroom: 6 modules - Legal & Immigration, Housing, Finance, Healthcare, Daily Life, Working in Mexico',
      '3 Mundalo City Guides (your choice)',
      'Vetted certified partner network - legal, health, housing & more',
      'Housing listings access',
    ],
  },
  guided: {
    id: 'guided',
    name: 'Guided',
    price: 549,
    priceLabel: '$549',
    interval: 'one-time',
    tagline: 'The fastest way there. A real human, three times.',
    description:
      'Everything in Essentials, plus three one-on-one calls with someone who has actually made this move. Bring your fears, leave with a plan. Designed to get you there within 6 months.',
    bullets: [
      'Everything in Essentials',
      'All 15 City Guides included',
      "3 strategy calls with a Mundalo advisor who's done this move",
      '1 full year of Community access ($95.88 value, included free)',
      'Vetted partners for THE MOVE + THE LIFE',
      'Housing listings + roommate finder',
    ],
  },
};

// Canonical ordering used by grid renderers.
export const PRICING_TIER_ORDER = ['blueprint_only', 'essentials', 'guided'];

// Convenience helpers for surfaces that just want the array form.
export const getPricingTiers = () =>
  PRICING_TIER_ORDER.map((k) => PRICING_CONTENT[k]);

export const getPricingTier = (id) => PRICING_CONTENT[id] || null;
